import styled from '@emotion/styled';
interface Props {
  gap?: string;
  alignItems?: string;
  justifyContent?: string;
}

const Column = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || '0'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
`;

export default Column;
